import ViewChannelVideos from './ViewChannelVideos'

export default ViewChannelVideos
